<ng-container *ngIf="isLoading; then loading else content"></ng-container>

<ng-template #loading>
  <div class="button-wrapper-dummy">
    <div class="panel-dummy">
      <div class="shine"></div>
    </div>
  </div>

  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="button-wrapper-dummy">
    <div class="panel-dummy">
      <div class="shine"></div>
    </div>
    <div class="panel-dummy">
      <div class="shine"></div>
    </div>
  </div>
</ng-template>

<ng-template #content>
  <h2 class="panel-title">{{('Modules.Licenses.List.OrderHistory.Orders' | translate)}}</h2>

  <app-search-bar [title]="'Components.SearchBar.Title' | translate" [placeholder]="'Components.SearchBar.Placeholder' | translate"
    (onSearchTextChanged)="onSearchTextChanged($event)"></app-search-bar>

  <div *ngIf="orderedLicenses.length">
    <div class="padding-list">
      <ng-container *ngFor="let order of orderedLicenses">
        <app-list-item title="{{ order.id }}" [info]="getInfoString(order)" showActionIcon="true"
          (click)="onOrderClick(order)" [showItemStatus]="false"  [disabled]="isLoadingOrderDetails">
        </app-list-item>        
      </ng-container>

      <div class="action-buttons" *ngIf="hasMore">
        <ng-container *ngIf="isLoadingMore; then loading else loadAction"></ng-container>
    
        <ng-template #loadAction>
          <button mat-flat-button class="button small-button" (click)="loadMore()">
            <mat-icon>update</mat-icon>
            <p>{{ 'General.LoadMore' | translate }}</p>
          </button>
        </ng-template>
    
        <ng-template #loading>
          <mat-spinner class="spinner" diameter="28"></mat-spinner>
        </ng-template>
      </div>
    </div>
  </div>
  <div *ngIf="orderedLicenses?.length === 0 && !isLoadingMore" class="panel-no-data">
    {{ (searchText.length > 0 ? 'Modules.Licenses.List.OrderHistory.NoOrderFiltered' : 'Modules.Licenses.List.OrderHistory.NoData') | translate: { filter: searchText } }}
  </div>
  <div *ngIf="orderedLicenses?.length === 0 && isLoadingMore">
    <mat-spinner class="spinner" diameter="28"></mat-spinner>
  </div>

</ng-template>